export default __webpack_public_path__ + "static/media/Bg-9.db903777.png";